import { ALLOWED_ATTEMPTS } from "../utils/constants"

export const maxAttemptsForGrammarFillInBlank = (numberOfCues, numberOfBlanks, blankAllowed=false) => {
  const numberOfPossibleInputs = blankAllowed ? numberOfCues + 1 : numberOfCues
  const possiblePermutations = Math.pow(numberOfPossibleInputs, numberOfBlanks)

  return Math.min(possiblePermutations - 1, ALLOWED_ATTEMPTS)
}
